/**
 * Liczba ofert zapisana tak, jak zapisuje ją język oglądającego — z separatorem tysięcy
 * (decyzja Piotra 2026-09-26). Jedno miejsce dla trzech przycisków i nagłówka, żeby ta
 * sama liczba nie wyglądała w nich różnie.
 *
 * DWIE PUŁAPKI, OBIE ZMIERZONE, OBIE CICHE:
 *
 * 1. `Intl.NumberFormat('pl')` **NIE grupuje liczb czterocyfrowych** — daje „3909", a nie
 *    „3 909". To nie usterka przeglądarki, tylko reguła polskiej lokalizacji
 *    (`minimumGroupingDigits: 2`); to samo robi białoruska. Dlatego wymuszone grupowanie
 *    jest tu obowiązkowe, a nie ozdobne — bez niego decyzja „ma być separator" działałaby
 *    dopiero od 10 000 w górę, czyli praktycznie nigdy przy naszych liczbach ofert.
 *
 * 2. Nasze kody języków to `ua` i `by`, a to **nie są kody języków** — to kody krajów.
 *    `Intl.NumberFormat('ua')` nie rzuca błędem: po cichu bierze język SYSTEMU. Na
 *    komputerze z polską lokalizacją wygląda to poprawnie, a u kogoś z angielskim systemem
 *    Ukrainiec zobaczyłby „3,909" z przecinkiem. Mapowanie na `uk` i `be` jest więc
 *    warunkiem poprawności, nie kosmetyką — dokładnie jak w `dateFnsLocale`.
 *
 * Separator w polskim to twarda spacja (U+00A0), więc liczba nigdy nie złamie się w pół.
 */
const TAGI: Record<string, string> = { pl: 'pl', en: 'en', ua: 'uk', by: 'be' };

export function formatLiczby(n: number, lang: string): string {
  const tag = TAGI[lang.slice(0, 2)] ?? 'en';
  // `useGrouping: true` znaczy w normie to samo co `'always'` (sprawdzone: polski i
  // białoruski dają wtedy „3 909" zamiast „3909"), a wersja napisowa nie mieści się w
  // typach `lib` tej konfiguracji TypeScriptu. Wartość logiczna działa i nie wymaga
  // rzutowania, więc bierzemy ją zamiast obchodzić typy.
  return new Intl.NumberFormat(tag, { useGrouping: true }).format(n);
}
